/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Skin tone variation for emoji reactions
 * @export
 */
export const SkinTone = {
    Default: 'default',
    Light: 'light',
    MediumLight: 'medium_light',
    Medium: 'medium',
    MediumDark: 'medium_dark',
    Dark: 'dark'
};
export function instanceOfSkinTone(value) {
    for (const key in SkinTone) {
        if (Object.prototype.hasOwnProperty.call(SkinTone, key)) {
            if (SkinTone[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function SkinToneFromJSON(json) {
    return SkinToneFromJSONTyped(json, false);
}
export function SkinToneFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SkinToneToJSON(value) {
    return value;
}
export function SkinToneToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
